import {axios} from "@/api/config";
// 查询检查项列表
export function listRecord(params) {
  return axios.get('/hiddenSpecialCheckrecord/list', params, true);
}

// 查询检查项详细
export function getRecord(recordId) {
  return axios.get(`/hiddenSpecialCheckrecord/${recordId}`, recordId, true)
}

// 新增检查项
export function addRecord(params) {
  return axios.post('/hiddenSpecialCheckrecord/add', params, false);
}

// 修改检查项
export function updateRecord(params) {
  return axios.post('/hiddenSpecialCheckrecord/edit', params, false);
}

// 删除检查项
export function delRecord(recordId) {
  return axios.delete(`/hiddenSpecialCheckrecord/${recordId}`, true)
}
